'use client';

import React from 'react';

export const SignatureSection = ({ formData, handleInputChange, errors }) => {
  return (
    <>
      <label htmlFor="signature" className="text-[#373945] text-base font-medium mb-2 block">
        Signature
      </label>

      <div
        className={`p-2 mb-6 rounded-lg text-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] ${
          errors.signature ? 'border-2 border-[#D32F2F]' : 'border-2 border-[#006EB7]'
        }`}
      >
        <div className="p-4 bg-[#F3F4F8] bg-opacity-75">
          <div className="text-[#373945] text-sm font-medium pb-10">Type your signature below</div>
          <input
            type="text"
            id="signature"
            name="signature"
            value={formData.signature}
            onChange={handleInputChange}
            placeholder="John Smith"
            className="w-full bg-[#F3F4F8] bg-opacity-75 font-parisienne font-normal text-[#373945] text-6xl focus:outline-none focus:border-[#006EB7] caret-[#006EB7] text-center underline decoration-[#CBCDD6] decoration-opacity-30 decoration-2 underline-offset-[2px]"
          />
        </div>

        <div className="text-sm pt-4 text-[#373945] font-450">
          By signing this registration form with your electric signature, you are agreeing to our{' '}
          <a
            href="https://puremediastorage.blob.core.windows.net/pure-web-media/general_process/terms-of-business.pdf"
            className="text-[#006EB7] underline cursor-pointer font-550"
            target="_blank"
            rel="noopener noreferrer"
          >
            Standard Terms of Business
          </a>.
        </div>
      </div>
    </>
  );
};
